import { createSlice } from "@reduxjs/toolkit";

const accountPayablesSlice = createSlice({
  name: "accountPayables",
  initialState: {
    loading: false,
    error: null,
    accountPayables: [],
    totalCount: {},
    accountPayablesProfileUiid: null,
    currentAccountPayables: {
      details: {},
      loadedTabs: [],
    }, // Add this for single employee data
  },
  reducers: {
    // getAccountPayablesStart(state, action) {
    //   state.loading = true;
    // },
    // getAccountPayablesSuccess(state, action) {
    //   state.loading = false;
    //   state.accountPayables = action.payload.data; // Store paginated data
    // },
    // getAccountPayablesFailure(state, action) {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
    clearAccountPayablesData(state) {
      state.accountPayables = [];
      state.totalCount = {};
      state.accountPayablesProfileUiid = null;
      state.currentAccountPayables = {
        details: {},
        loadedTabs: [],
      };
    },
    clearAccountPayablesProfile(state) {
      state.accountPayablesProfileUiid = null;
      state.currentAccountPayables = {
        details: {},
        loadedTabs: [],
      };
    },
    setAccountPayablesProfile(state, action) {
      console.log("object in slice", action.payload);
      state.currentAccountPayables.details = {
        ...state.currentAccountPayables.details,
        ...action.payload,
      };
    },
    getAccountPayablesStart(state, action) {
      state.loading = true;
    },
    getAccountPayablesSuccess(state, action) {
      state.loading = false;
      state.accountPayables = action.payload.data; // Store paginated data
      state.totalCount = action.payload.totalCount;
    },
    getAccountPayablesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    addAccountPayablesStart(state) {
      state.loading = true;
      state.error = null;
    },
    addAccountPayablesSuccess(state, action) {
      state.accountPayablesProfileUiid = action.payload.data.payableId;
      state.loading = false;
    },
    addAccountPayablesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateAccountPayablesStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateAccountPayablesSuccess(state, action) {
      state.loading = false;
    },
    updateAccountPayablesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getAccountPayablesOneStart(state) {
      state.loading = true;
      state.error = null;
    },
    getAccountPayablesOneSuccess(state, action) {
      state.loading = false;
      state.accountPayablesProfileUiid =
        action.payload.data.uiid || state.accountPayablesProfileUiid;
      state.currentAccountPayables.details = {
        ...state.currentAccountPayables.details,
        ...action.payload.data,
      };
    },
    getAccountPayablesOneFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.currentAccountPayables = {
        details: {},
        loadedTabs: [],
      };
    },
    resetCurrentAccountPayables(state) {
      state.currentAccountPayables = {
        details: {},
        loadedTabs: [],
      };
    },
  },
});

export const {
  clearAccountPayablesData,
  setAccountPayablesProfile,
  getAccountPayablesStart,
  getAccountPayablesSuccess,
  getAccountPayablesFailure,
  addAccountPayablesStart,
  addAccountPayablesSuccess,
  addAccountPayablesFailure,
  updateAccountPayablesStart,
  updateAccountPayablesSuccess,
  updateAccountPayablesFailure,
  getAccountPayablesOneStart,
  getAccountPayablesOneSuccess,
  getAccountPayablesOneFailure,
  resetCurrentAccountPayables,
} = accountPayablesSlice.actions;

export default accountPayablesSlice.reducer;
